import { Alert, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import variables from "../../../styles/utils.module.scss";
import CheckboxWithLabel from "../../../components/CheckboxWithLabel";
import axios from "axios";
import { getMessagesUserType, serverUrl } from "../../../helpers/utility";
import { mutate } from "swr";
import InputWithLabel from "../../../components/inputWithLabel";
import InputWithSelect from "../../../components/inputWithSelect";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

function CompleteEnquiryModal({ enquiry, placement, location, show, close, size, user }) {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    setError,
    clearErrors,
    trigger,
    reset,
  } = useForm();
  const formValues = watch();
  const [sent, markSent] = useState(false);
  const [enquiryData, setEnquiryData] = useState(null);
  let navigate = useNavigate();

  // Frequency options for the dropdown
  const frequencyOptions = [
    { value: "per_week", label: "Per Week" },
    { value: "per_month", label: "Per Month" },
  ];

  if (typeof close !== "function") {
    console.error(`CompleteEnquiryModal missing close function!`);
    return <></>;
  }

  useEffect(() => {
    return () => {
      resetModal();
    };
  }, []);

  function resetModal() {
    markSent(false);
    setEnquiryData(null);
    reset();
  }

  function viewEnquiry() {
    navigate(`/enquiry?enquiryId=${enquiryData?._id}`);
    resetModal();
  }

  async function confirmSuitableEnquiry() {
    try {
      console.log(`sendCompleteEnquiry`);

      const response = await axios.put(`${serverUrl}/enquiry`, {
        _id: enquiry._id,
        placementId: placement._id,
        careProviderLocationId: location._id,
        careProviderOrganisationId: location.careProviderOrganisationId,
        completed: true,
        suitable: true,
        suitableAt: new Date(),
        suitableBy: user.email,
      });

      // await axios.put(`${serverUrl}/placement`, {
      //   _id: placement._id,
      //   hasBeenPlaced: true,
      //   careProviderLocationId: location._id,
      //   careProviderOrganisationId: location.careProviderOrganisationId,
      // });

      if (response && response?.data?.result?._id) {
        markSent(true);
        setEnquiryData(response.data.result);
        navigate(`/enquiry?enquiryId=${enquiry._id}`);
      }
    } catch (error) {
      console.error(`Complete enquiry error: ${error}`);
      close();
    }
  }

  return (
    <Modal show={show} onHide={close} size={size || "lg"} centered>
      <Modal.Header closeButton>
        <Modal.Title>Complete Enquiry</Modal.Title>
      </Modal.Header>

      {!sent ? (
        <>
          <Modal.Body>
            <Form>
              <p>Please confirm that this enquiry is suitable for the placement. <br /> The Local Authority will be notified and the placement will be marked as completed.</p>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                close();
                resetModal();
              }}
            >
              No, go back
            </Button>
            <Button variant="primary" onClick={confirmSuitableEnquiry}>
              Confirm Suitable
            </Button>
          </Modal.Footer>
        </>
      ) : null}

      {sent ? (
        <>
          <Modal.Body>
            <Alert variant="success">Enquiry has been confirmed as suitable.</Alert>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                close();
                resetModal();
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </>
      ) : null}
    </Modal>
  );
}

export default CompleteEnquiryModal;
